import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDp5KPnPNrEz0TrT3VTZJr921B1R5BatVA",
  authDomain: "vision-googz.firebaseapp.com",
  databaseURL: "https://vision-googz.firebaseio.com",
  projectId: "vision-googz",
  storageBucket: "vision-googz.appspot.com",
  messagingSenderId: "662911128540",
  appId: "1:662911128540:web:aeb694a1be507b43e0f519",
  measurementId: "G-HLGCX8WD00"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const storage = firebase.storage();
const auth = firebase.auth();
const functions = firebase.functions();
const storageRef = storage.ref();
const ref = firebase.database().ref();

export { auth, ref, firebase, functions, storage, storageRef };